import type { CityConfig } from "../city-template/types";

export const johnstonIAConfig: CityConfig = {
  city: "Johnston",
  state: "Iowa",
  stateAbbr: "IA",
  slug: "johnston-ia",
  route: "/cities/johnston-ia",
  title: "Emergency Passport Johnston, IA | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Johnston, IA — as fast as 24 hours. Serving the northwest Des Moines metro. A+ BBB rated registered State Dept. courier serving Pioneer Hi-Bred and Corteva professionals, Camp Dodge personnel, and Johnston-Grimes metro travelers. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Johnston, IA",
  heroSubtitle: "Corteva Agriscience international conference in Brazil and company travel arranged last minute? Camp Dodge deployment orders arrived and your passport is expired? Pioneer seed research trip to Chile starting next week? We help Johnston and northwest metro residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Johnston%20Iowa%20modern%20suburban%20landscape%20with%20Pioneer%20Hi%20Bred%20headquarters%20campus%20Camp%20Dodge%20military%20base%20and%20Saylorville%20Lake%20area%20northwest%20Des%20Moines%20metro%20at%20golden%20hour%20warm%20sunlight%20professional%20corporate%20setting&width=1800&height=700&seq=johnston-ia-hero-2026&orientation=landscape",
  heroImageAlt: "Johnston Iowa Pioneer Hi-Bred campus and northwest Des Moines metro area at golden hour",
  geoPosition: "41.6731;-93.6977",
  geoPlacename: "Johnston, Iowa",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B Wells Dr, 9th Floor, Chicago, IL 60604",
    distance: "Located in the Chicago Loop — approximately 335 miles east of Johnston via I-80",
  },
  nearbyCitiesZips: [
    { name: "Johnston", zips: "50131" },
    { name: "Grimes", zips: "50111" },
    { name: "Urbandale", zips: "50322, 50323" },
    { name: "Ankeny", zips: "50021, 50023" },
    { name: "Des Moines", zips: "50301–50327" },
    { name: "West Des Moines", zips: "50265, 50266" },
    { name: "Clive", zips: "50325" },
    { name: "Waukee", zips: "50263" },
    { name: "Altoona", zips: "50009" },
    { name: "Pleasant Hill", zips: "50327" },
    { name: "Ames", zips: "50010–50014" },
    { name: "Indianola", zips: "50125" },
    { name: "Norwalk", zips: "50211" },
    { name: "Pella", zips: "50219" },
    { name: "Boone", zips: "50036" },
    { name: "Marshalltown", zips: "50158" },
    { name: "Iowa City", zips: "52240–52246" },
    { name: "Cedar Rapids", zips: "52401–52411" },
    { name: "Coralville", zips: "52241" },
    { name: "Grinnell", zips: "50112" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent northwest metro departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "NW Metro Coverage", desc: "Serving Johnston, Grimes, Urbandale, and Des Moines metro" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Des Moines, IA", route: "/cities/des-moines" },
    { name: "Fast passport renewal in West Des Moines, IA", route: "/cities/west-des-moines" },
    { name: "Emergency passport help in Ankeny, IA", route: "/cities/ankeny" },
    { name: "Urgent passport services in Ames, IA", route: "/cities/ames" },
    { name: "Same-day passport help in Urbandale, IA", route: "/cities/urbandale" },
    { name: "Passport courier services in Cedar Rapids, IA", route: "/cities/cedar-rapids" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Johnston remotely via secure courier. We do not have a walk-in office in Johnston — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for the northwest Des Moines metro region.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of the northwest Des Moines metro region including Johnston, Grimes, Urbandale, Clive, and surrounding communities",
  serviceAreaIntro: "From the Pioneer Hi-Bred and Corteva Agriscience global headquarters campus to Camp Dodge with its Iowa National Guard deployments, from the award-winning Johnston Community School District with international exchange programs to the Beaver Creek Elementary and Summit Middle School communities, from the growing residential neighborhoods along Merle Hay Road to the Saylorville Lake recreation area nearby — Fast Passport Center serves the entire Johnston region. We regularly help travelers from Johnston, Grimes, Urbandale, and Clive get their passports fast without the 5-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Johnston neighborhoods and the surrounding northwest Des Moines metro area including Grimes, Urbandale, Ankeny, Clive, and Waukee. If you are anywhere in the northwest Des Moines metro region, we have you covered.",
  howItWorksIntro: "Most Johnston travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Des Moines metro travelers often face a 5-plus-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Johnston and northwest metro travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Johnston? Here are the most common ones we hear from northwest metro travelers.",
  statePageRoute: "/states/iowa",
  statePageName: "Iowa",
  dmvWebsite: "https://iowadot.gov/mvd",
  dmvLabel: "Iowa DOT — Motor Vehicle Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Johnston travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Sarah C.",
      location: "Johnston, IA",
      rating: 5,
      text: "Corteva sent me to a global agriscience summit in São Paulo with 6 days notice. Fast Passport Center renewed my passport in 2 days. My director was blown away. Now our entire travel department recommends them.",
      service: "Passport Renewal",
    },
    {
      name: "Sgt. Mike D.",
      location: "Grimes, IA",
      rating: 5,
      text: "Camp Dodge deployment orders to Germany — my passport expired. Fast Passport Center's courier got it done in 3 days. Made my unit's departure date. My CO asked for the info to share with the rest of the battalion.",
      service: "Emergency Passport",
    },
    {
      name: "Linda and Tom W.",
      location: "Johnston, IA",
      rating: 5,
      text: "Retirement trip to Italy — booked months ago but we forgot to check our passports. Both expired. Fast Passport Center got them back in 4 days. We made our flight to Rome with 2 days to spare.",
      service: "Passport Renewal",
    },

  ],
  facilities: [
    {
      id: "johnston-1",
      name: "Johnston Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5900 Merle Hay Rd",
      city: "Johnston",
      state: "IA",
      zip: "50131",
      phone: "(515) 278-2948",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Johnston city center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Johnston facility. Serves Johnston-Grimes metro. Appointments strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "johnston-2",
      name: "Urbandale Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3319 100th St",
      city: "Urbandale",
      state: "IA",
      zip: "50322",
      phone: "(515) 251-7468",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles south of Johnston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Urbandale and northwest Des Moines. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "johnston-3",
      name: "Grimes Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 SE Gateway Dr",
      city: "Grimes",
      state: "IA",
      zip: "50111",
      phone: "(515) 986-3341",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles west of Johnston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Grimes and western Polk County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "johnston-4",
      name: "Ankeny Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1011 N Ankeny Blvd",
      city: "Ankeny",
      state: "IA",
      zip: "50023",
      phone: "(515) 964-2401",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles northeast of Johnston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Ankeny and northern Polk County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "johnston-5",
      name: "Des Moines Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1165 2nd Ave",
      city: "Des Moines",
      state: "IA",
      zip: "50318",
      phone: "(515) 283-7594",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "10 miles south of Johnston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest USPS facility in the metro. Extended hours and Saturday appointments available.",
      icon: "ri-mail-line",
    },
    {
      id: "johnston-6",
      name: "Clive Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2135 NW 108th St",
      city: "Clive",
      state: "IA",
      zip: "50325",
      phone: "(515) 253-9840",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles southwest of Johnston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Clive and western suburbs. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5+ hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photo shops in the Des Moines metro often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Polk County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Johnston applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Johnston Community School District families at the county clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Johnston corporate travelers often assume business travel departments handle everything. Always check your passport 6 months before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Johnston." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Johnston address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Johnston before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Johnston for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5-plus-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Johnston?", a: "Fast Passport Center offers fast passport renewal in Johnston in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Johnston?", a: "The nearest regional passport agency to Johnston is the Chicago Passport Agency, approximately 335 miles east via I-80. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Johnston without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Johnston?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 5-plus hours from Johnston — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for northwest Des Moines metro residents." },
    { q: "Do you serve Corteva and Pioneer employees?", a: "Absolutely. Fast Passport Center regularly serves Corteva Agriscience and Pioneer Hi-Bred professionals needing fast passports for international business travel. Our courier service handles everything online — you never leave your office. Dozens of Johnston corporate travelers trust us every month." },
    { q: "Can I expedite a child passport in Johnston?", a: "Yes. Fast Passport Center expedites child passports in Johnston for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Johnston Community School District families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Johnston with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart — Ankeny", address: "1002 SE National Dr, Ankeny, IA 50021", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Urbandale", address: "8430 Douglas Ave, Urbandale, IA 50322", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Grimes", address: "2150 E 1st St, Grimes, IA 50111", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Johnston", address: "5900 Merle Hay Rd, Johnston, IA 50131", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Des Moines", address: "3400 SE 14th St, Des Moines, IA 50320", hours: "Mon–Sun: 8AM–10PM" },
    { name: "FedEx Office — West Des Moines", address: "6305 Mills Civic Pkwy, West Des Moines, IA 50266", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "Iowa DOT — Ankeny Driver's License",
      address: "6310 SE Convenience Blvd, Ankeny, IA 50021",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Primary DMV for the northwest Des Moines metro. REAL ID available. Appointment recommended.",
      featured: true,
    },
    {
      name: "Iowa DOT — Des Moines Driver's License",
      address: "1434 Locust St, Des Moines, IA 50309",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Downtown Des Moines location. REAL ID available.",
      featured: false,
    },
    {
      name: "Iowa DOT — Ames Driver's License",
      address: "1900 S Dayton Ave, Ames, IA 50010",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Story County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "DSM",
      name: "Des Moines International Airport",
      distance: "15 miles south of Johnston",
      address: "5800 Fleur Dr, Des Moines, IA 50321",
      note: "Iowa's largest airport with direct flights nationwide. About 20 minutes from Johnston.",
      flightUrl: "https://www.dsmairport.com/",
      flightLabel: "DSM Airport",
      featured: true,
    },
    {
      code: "CID",
      name: "Eastern Iowa Airport",
      distance: "120 miles east of Johnston",
      address: "2121 Arthur Collins Pkwy SW, Cedar Rapids, IA 52404",
      note: "Serves Cedar Rapids and Eastern Iowa. About 2 hours from Johnston.",
      flightUrl: "https://www.eiairport.org/",
      flightLabel: "CID Airport",
      featured: false,
    },
    {
      code: "IKV",
      name: "Ankeny Regional Airport",
      distance: "10 miles northeast of Johnston",
      address: "3700 SE Convenience Blvd, Ankeny, IA 50021",
      note: "Regional airport with general aviation and charter services. About 15 minutes from Johnston.",
      flightUrl: "https://www.ankenyiowa.gov/",
      flightLabel: "IKV Airport",
      featured: false,
    },
  ],
};